import { create, devtools } from 'lib/zustand';
import type { Image } from 'models';

type BrandingAction = {
  reset: () => void;
  setLogo: (image?: Image) => void;
};

type BrandingState = {
  logo: {
    src: string;
    srcSet: string;
  };
};

const defaultLogoPath = ({ fileName }: { fileName: string }) => `/${import.meta.env.VITE_APP_CONFIG}/dark/${fileName}`;

const initialState: BrandingState = {
  logo: {
    src: defaultLogoPath({ fileName: 'logo.png' }),
    srcSet: `${defaultLogoPath({ fileName: 'logo.png' })} 320w, ${defaultLogoPath({ fileName: 'logo@2x.png' })} 630w, ${defaultLogoPath(
      { fileName: 'logo@3x.png' },
    )} 940w`,
  },
};

const useBrandingStore = create<BrandingAction & BrandingState>()(
  devtools((set) => ({
    ...initialState,
    reset() {
      set(initialState);
    },
    setLogo(image) {
      set({ logo: image ? { src: image.url, srcSet: image.url } : initialState.logo });
    },
  })),
);

export const useBrandingLogo = () => useBrandingStore((state) => state.logo);

export const useSetBrandingLogo = () => useBrandingStore((state) => state.setLogo);
